import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { useCphContext } from "../../hooks/useCphContext";
import { useCphDataContext } from "../../hooks/useCphDataContext";
import { useDeleteFile } from "../../services/ApiHandlerService";
import { CphConstants } from "../../constants/CphConstants";

interface UploadCollectionCardProps {
    uploadType: "user" | "staff";
}

// Helper to remove any # and all characters left of it
function stripPath(str: string): string {
    const idx = str.lastIndexOf('\\');
    return idx !== -1 ? str.substring(idx + 1) : str;
}

const UploadCollectionCard: React.FC<UploadCollectionCardProps> = ({ uploadType }) => {
    const { isStaff } = useCphContext();
    const { selectedIssue } = useCphDataContext();
    const { deleteFile } = useDeleteFile();

    if (!selectedIssue) {
        return <Typography variant="body1">No issue selected.</Typography>;
    }

        const handleDelete = React.useCallback(async (fileDto: any) => {
            if (fileDto) {
                try {
                    await deleteFile(fileDto);
                } catch (e) {
                    alert('Error deleting file.');
                }
            }
        }, [deleteFile]);

    const isUser = uploadType === "user" ? 1 : 0;
    const labelPrefix = "Files Uploaded By ";
    const labelSuffix = isUser === 1 ? "Reporter" : CphConstants.StaffSignature;
    const collectionTitle = `${labelPrefix}${labelSuffix}`;

    const collection = Array.isArray(selectedIssue.fileUploads)
        ? selectedIssue.fileUploads.filter(f => f.isUser === isUser)
        : [];

    return (
        <Card sx={{ maxWidth: 400, margin: 2, boxShadow: 'none !important', border: 0 }}>
            <CardContent>
                <Typography variant="body2">
                    <strong>{collectionTitle}</strong>
                </Typography>
                {collection.length === 0 ? (
                    <Typography variant="body2">No files uploaded.</Typography>
                ) : (
                    collection.map((file, index) => {
                        // Create IFileDto for each file
                        const fileDto = {
                            fileKey: file.uploadKey as string,
                            fileName: stripPath(file.fileName as string),
                            filePath: file.fileName as string
                        };
                        // Import handleDownload from FileService
                        const { handleDownload } = require('../../services/FileService');
                        return (
                            <div key={index} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 4 }}>
                                <span
                                    style={{
                                        color: '#1976d2',
                                        cursor: 'pointer',
                                        flex: 1,
                                        textDecoration: 'underline',
                                        background: '#f5f5f5',
                                        padding: '2px 8px',
                                        borderRadius: 4
                                    }}
                                    onClick={() => handleDownload(fileDto)}>
                                    {fileDto.fileName}
                                </span>
                                { (isStaff || file.isUser === 1) && (
                                    <span
                                        style={{ color: 'red', cursor: 'pointer', marginLeft: 12, fontWeight: 'bold', fontSize: 18 }}
                                        onClick={async (e) => { e.stopPropagation(); await handleDelete(fileDto); }}>
                                        x
                                    </span>
                                )}
                            </div>
                        );
                    })
                )}
            </CardContent>
        </Card>
    );
};

export default UploadCollectionCard;
